import Icon from '../components/Icon.vue'

Icon.register({
  'file-archive': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136V0H160.4V32H128.4V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM95.9 32H127.9V64H95.9V32zM128.2 416C95 416 70.2 385.6 76.8 353.1L96.4 256V224H128.4V192H96.4V160H128.4V128H96.4V96H128.4V64H160.4V96H128.4V128H160.4V160H128.4V192H160.4V224H128.4V256H150.5C156.2 256 161.2 260.1 162.3 265.7L179.6 353.4C186 385.8 161.2 416 128.2 416zM160.9 363C160.9 377.9 146.4 390 128.5 390S96 378 96 363C96 348.1 110.5 336 128.4 336S160.9 348.1 160.9 363zM384 121.9V128H256V0H262.1C268.5 0 274.6 2.5 279.1 7L377 105C381.5 109.5 384 115.6 384 121.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-archive.js
// module id = 9iFU
// module chunks = 144